import getFormValues from '../../utils/newforms/getFormValues'

export const buildUtmBuilderFormValues = ({
  form,
  relatedBrands = [],
  relatedCategory = null,
  relatedProduct = null,
  relatedPromo = null,
}) => ({
  ...getFormValues({ form }),
  related_brand_ids: relatedBrands.map((brand) => brand.id),
  related_brands: relatedBrands,
  related_category: relatedCategory,
  related_category_level: relatedCategory?.related_category_level ?? null,
  related_category_source: relatedCategory?.related_category_source ?? null,
  related_global_category_id: relatedCategory?.related_global_category_id ?? null,
  related_global_category_name: relatedCategory?.related_global_category_name ?? null,
  related_outlet_global_category_id: relatedCategory?.related_outlet_global_category_id ?? null,
  related_global_category_path: relatedCategory?.related_global_category_path ?? null,
  related_category_path_label: relatedCategory?.related_category_path_label ?? null,
  related_product_filter: relatedCategory?.related_product_filter ?? null,
  related_product_id: relatedProduct?.id ?? null,
  related_product_source: relatedProduct?.source ?? null,
  related_product_name: relatedProduct?.name ?? null,
  related_product_barcode: relatedProduct?.barcode ?? null,
  related_product_label: relatedProduct?.label ?? null,
  related_product: relatedProduct,
  related_promo_id: relatedPromo?.id ?? null,
  related_promo_title: relatedPromo?.title ?? null,
  related_promo_start_date: relatedPromo?.startDate ?? null,
  related_promo_end_date: relatedPromo?.endDate ?? null,
  related_promo_source: relatedPromo?.source ?? null,
  related_promo: relatedPromo,
})

export default buildUtmBuilderFormValues
